import React from 'react'
import { Redirect, RouteComponentProps } from '@reach/router'

export const RedirectPage: React.FC<RouteComponentProps & { to: string }> = (props) => (
    <Redirect to={props.to} noThrow />
)
